import '../../admin-shared.css'

import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import { useRef, useState } from 'react'

import { PageHeader } from '../../../../Components'
import { cap } from '../../../../State'
import { translations } from '../../../../translations'
import { showToast } from '../../../../utils/toast'
import { ImportTutorial, TextEditor } from './Components'
import { readClients, uploadClients } from './Functions'

const language = cap.language.state || 'IT'
const t = translations[language]

export const TravellersImport = () => {
  const refReadClients = useRef(null)
  const [importedClients, setImportedClients] = useState([])

  const importClients = async (e) => {
    const res = await readClients(e)
    if (!res) return showToast('error', t.errore, t.mxErroreImportazioneViaggiatori)
    showToast('success', t.success, `${t.mxTrovati} ${res.length} ${t.mxViaggiatori}`)
    setImportedClients(res)
  }

  const onRowEditComplete = ({ newData, index }) => {
    const _products = [...importedClients]
    _products[index] = newData
    setImportedClients(_products)
  }

  const confirmClients = async () => {
    await uploadClients(importedClients)
    setImportedClients([])
  }

  return (
    <div className="admin-page--wide">
      <PageHeader
        title={t.admImportaViaggiatori}
        subtitle={t.admSottotitoloImport}
        actions={
          <>
            <button type="button" className="nbtn" onClick={() => refReadClients.current.click()}>
              <i className="pi pi-upload" style={{ fontSize: 14 }} />
              {t.admCaricaCSV}
            </button>
            {!!importedClients?.length && (
              <button type="button" className="nbtn nbtn--primary" onClick={confirmClients}>
                <i className="pi pi-check" style={{ fontSize: 14 }} />
                {t.admCaricaSuDB}
              </button>
            )}
          </>
        }
      />

      <input
        type="file"
        accept=".csv"
        ref={refReadClients}
        style={{ display: 'none' }}
        onChange={(e) => importClients(e)}
      />

      {!importedClients?.length ? (
        <div className="ncard travellers-import-upload">
          <div className="ncard__body">
            <ImportTutorial />
          </div>
        </div>
      ) : (
        <div className="ncard admin-table-card" style={{ padding: 0 }}>
          <div className="ncard__head">
            <div className="ncard__ico">
              <i className="pi pi-users" style={{ fontSize: 16 }} />
            </div>
            <div>
              <h3 className="ncard__title">{t.admAnteprimaFile}</h3>
              <div className="ncard__sub">
                {importedClients.length}
                {t.admViaggiatoriDaImportare}
              </div>
            </div>
          </div>
          <DataTable
            style={{ width: '100%' }}
            sortField="createdAt"
            sortOrder={-1}
            scrollHeight="70vh"
            value={importedClients}
            emptyMessage={t.admNienteDaVisualizzare}
            responsiveLayout="scroll"
            paginator
            rows={10}
            className="TableSignatures ntable travellers-import-table"
            filterDisplay="row"
            onRowEditComplete={onRowEditComplete}
            editMode="row"
            rowClassName={(row) => (row._error ? 'travellers-import-row--error' : '')}
          >
            {Object.keys(importedClients[0]).map((key, ind) => (
              <Column
                key={ind}
                header={key}
                alignHeader="center"
                showClearButton={false}
                filter
                filterMatchMode="contains"
                style={{ textAlign: 'center' }}
                sortable
                filterPlaceholder={'🔍   ' + key}
                showFilterMenu={false}
                field={key}
                body={({ [key]: value }) => (
                  <span
                    style={{
                      fontFamily: key === 'pid' ? 'var(--font-mono)' : 'inherit',
                      fontSize: key === 'pid' ? 12 : 13
                    }}
                  >
                    {value}
                  </span>
                )}
                editor={(options) => TextEditor(options)}
              />
            ))}
            <Column
              rowEditor
              headerStyle={{ width: '10%', minWidth: '8rem' }}
              bodyStyle={{ textAlign: 'center' }}
            />
          </DataTable>
        </div>
      )}
    </div>
  )
}
